export function useAddToCartAvailability(product) {
  const isAddToCartAvailable = computed(() => {
    const isPricingAvailable = !!product.translated?.customFields?.priceAvailable;
    return product?.extensions?.vendorAvailability?.isAvailable && isPricingAvailable;
  });

  return { isAddToCartAvailable };
}

